const Index = () => import("./index.vue");
const List = () => import("./components/List.vue");
export default [{ path: "invoiceExitGuard", component: Index, children: [{ path: "", name: "invoice-exit-guard", component: List }] }];
